import React from 'react';
import { GRID_FILTER_KEYS } from '../../../Base/Components/GridFilter/gridFilterKeys';
import GridFilterItem from '../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../Base/Enums/GridFilterItemType.enum';
import GridFilter from '../../../Base/Components/GridFilter/GridFilter';
import useFilters from '../../../Base/Hooks/useFilters';

interface LaboratoryResultsFilerValues {
	userId?: string;
}

interface Props {
	onFilter: (values: LaboratoryResultsFilerValues) => void;
}

const LaboratoryResultsFiler: React.FC<Props> = ({ onFilter }) => {
	const { checkEmptyString } = useFilters();

	const onFilterData = (values: any) => {
		const filter: LaboratoryResultsFilerValues = {
			userId: values?.patient
				? checkEmptyString(values?.patient?.value)
				: undefined,
		};

		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={(values: any) => onFilterData(values)}
			storageKey={GRID_FILTER_KEYS.LABORATORY_RESULTS}>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_ID}
				width={320}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default LaboratoryResultsFiler;
